export default class Search {

    constructor(){
        this.searchIcon = document.querySelector("#searchIcon");
        this.navBar = document.querySelector("#navbar-nav");
        this.searchBarDismiss = document.querySelector("#searchIcon_close");

        if(this.searchBarDismiss && this.searchIcon){
            [this.searchIcon, this.searchBarDismiss].forEach( btn => {btn.addEventListener("click", this.clickHandler.bind(this))});
        }

        this.searchBar = document.querySelector("#searchform");
        this.autoComplete = new AutoCompletionSearch(this.searchBar);
    }

    clickHandler(e){
        e.preventDefault();

        // Main navigation / nav bar
        this.navBar.classList.toggle("d-none");
        this.navBar.classList.toggle("flex-grow-1");
        this.navBar.parentElement.classList.toggle("flex-grow-1");

        // Search icon and searchbar
        this.searchBar.classList.toggle("d-none");
        this.searchIcon.classList.toggle("d-none");

        // Search dismiss
        this.searchBarDismiss.classList.toggle("d-none");
    }
}


class AutoCompletionSearch {

	constructor(element) {

        this.resultList = document.querySelector("#suggestionsAutocompleteList");

		let _this = this;
        this.autoCompletions = { suggestions: [], autocomplete: [] };
		wp.api.loadPromise.done(function () {
            Promise.all([
                _this.iterateEndpoint(window.location.origin + '/wp-json/wp/v2/posts?_fields=title,link'), 
                _this.iterateEndpoint(window.location.origin + '/wp-json/wp/v2/pages?_fields=title,link'),
                _this.iterateEndpoint(window.location.origin + '/wp-json/wp/v2/destination?_fields=title,link'),
                _this.iterateEndpoint(window.location.origin + '/wp-json/wp/v2/event?_fields=title,link')
                /* fetch(window.location.origin + '/wp-json/wp/v2/instagram') */]).then(onFulfilled => {
                    let allPostTypes = [];
                    onFulfilled.forEach(postTypes => {
						postTypes.forEach( post => {
							allPostTypes.push(post);
						});
                    });

                    _this.autoCompletions.autocomplete = allPostTypes.map(post => {
                        return {
                            title: post.title.rendered,
                            slug: post.link
                        };
                    });

                    _this.init(element, _this.autoCompletions);

            }, onRejected => { }).then(() => {
                
            });
        });
		
	}

	async iterateEndpoint(request = ""){

		let allResponses = [];
		let page = 1;

		while(page < 50){
			let result = await fetch(request+`&per_page=100&page=${page}`);
			if(result.ok){
				const fulfilledRes = await result.json();
				allResponses = allResponses.concat(fulfilledRes);
				if(fulfilledRes.length == 100){
					page++;
				} else {
					break;
				}
			} else {
				break;
			}
		}

		return allResponses;
	}

	init(inp, autoCompletions) {


        let _this = this;

		var currentFocus;
		const uniqueId = String(Math.round(Math.random() * 1000));

		const arr = [...autoCompletions.suggestions, ...autoCompletions.autocomplete];

		inp.addEventListener('input', function (e) {

            closeAllLists();

			var a, b, i,
				val = inp.querySelector("input#s").value.toLowerCase();

			if (!val) {
				return false;
			}

			for (i = 0; i < arr.length; i++) {

                let title = arr[i].title.toLowerCase();

				if (title.includes(val)) {
					b = document.createElement('DIV');
					b.innerHTML = `<p class="mb-0">${arr[i].title.substring(0, title.indexOf(val))}<strong>${arr[i].title.substring(title.indexOf(val), title.indexOf(val) + val.length)}</strong>${arr[i].title.substring(title.indexOf(val) + val.length)}</p>`;
					b.innerHTML += '<input type=\'hidden\' value=\'' + arr[i].title + '\' data-slug=\'' + arr[i].slug + '\'>';
                    b.setAttribute('class', 'list-group-item autocomplete-items in-writing cursor-pointer');
					b.addEventListener('click', function (e) {
						inp.value = this.getElementsByTagName('input')[0].value;
						if (this.getElementsByTagName('input')[0].dataset.slug) {
							window.location.href = this.getElementsByTagName('input')[0].dataset.slug;
						}
					});
					_this.resultList.appendChild(b);
				}
			}

			/* appendViewResultsBtn(a); */
		});

		inp.addEventListener('keydown', function (e) {
			if (13 === e.keyCode) {
				inp.parentNode.parentNode.submit();
				return;
			}
			var x = document.getElementById(this.id + uniqueId + 'autocomplete-list');
			if (x) {
				x = x.getElementsByTagName('div');
			}
			if (40 == e.keyCode) {
				currentFocus++;
				addActive(x);
			} else if (38 == e.keyCode) {
				currentFocus--;
				addActive(x);
			} else if (13 == e.keyCode) {
				e.preventDefault();
				if (-1 < currentFocus) {
					if (x) {
						x[currentFocus].click();
					}
				}
			}
		});

		function addActive(x) {
			if (!x) {
				return false;
			}
			removeActive(x);
			if (currentFocus >= x.length) {
				currentFocus = 0;
			}
			if (0 > currentFocus) {
				currentFocus = (x.length - 1);
			}
			x[currentFocus].classList.add('autocomplete-active');
		}

		function removeActive(x) {
			for (var i = 0; i < x.length; i++) {
				x[i].classList.remove('autocomplete-active');
			}
		}

		function closeAllLists(elmnt) {
			var x = Array.from(document.getElementsByClassName('autocomplete-items'));
			if((elmnt && elmnt.id !== "s" && (elmnt.classList && !elmnt.classList.contains('autocomplete-items') )) || typeof elmnt === "undefined"){
				x.forEach((el) => {el.parentNode.removeChild(el);});
			}
		}

		document.addEventListener('click', function (e) {
			closeAllLists(e.target);
		});
	}

}
